import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackButtonComponent } from '../../common/back-button/back-button.component';
import { SposobNadaniaType } from 'src/app/enums/enums';
import { NavigationService } from 'src/app/services/navigation.service';
import { ApiService } from 'src/app/services/api.service';
import { firstValueFrom } from 'rxjs';
import { ErrorResponse } from 'src/app/models/error/error-response.model';
import { LabelRequest } from 'src/app/models/label/label-request.model';
import { LabelResponse } from 'src/app/models/label/label-response.model';
import { PageHeaderComponent } from '../../common/page-header/page-header.component';
import { CaptchaDialogService } from 'src/app/services/captcha-dialog.service';
import { StoreService } from 'src/app/services/store.service';
import { PointDto } from 'src/app/models/fds2-points/fds2-points.model';

@Component({
  selector: 'app-point-shipping-confirmation-page',
  standalone: true,
  imports: [CommonModule, BackButtonComponent, PageHeaderComponent],
  templateUrl: './point-shipping-confirmation-page.component.html',
  styleUrl: './point-shipping-confirmation-page.component.scss',
})
export class PointShippingConfirmationPageComponent {
  constructor(
    private navigationService: NavigationService,
    private apiService: ApiService,
    private captchaDialogService: CaptchaDialogService,
    protected storeService: StoreService
  ) {
    storeService.getShippingPointFormData();
  }

  isPageActive(): boolean {
    return (
      this.storeService.getSposobNadaniaTyp() ===
        SposobNadaniaType.NADAJ_W_PUNKCIE &&
      this.storeService.getSposobNadaniaStepNumber() === 1
    );
  }

  changePointButtonAction() {
    this.navigationService.changeSposobNadaniaStepNumberTo(0);
  }

  async getLabel() {
    try {
      const labelRequest = this.buildLabelRequest();
      const labelResponse = await firstValueFrom(
        this.apiService.submitLabelRequest(labelRequest)
      );
      this.downloadLabel(labelResponse);
    } catch (error) {
      this.handleLabelError(error);
    }
  }

  buildLabelRequest(): LabelRequest {
    return {
      shipmentNumbers: this.storeService.getShipNo()
        ? [this.storeService.getShipNo()!]
        : [],
      format: 'pdf',
      clientExt1Id: this.storeService.getPayerNo()?.toString(),
    };
  }

  downloadLabel(labelResponse?: LabelResponse) {
    if (!labelResponse?.dataB64) {
      console.error('No dataB64 in label response');
      //todo zaksa
      return;
    }

    const byteCharacters = atob(labelResponse.dataB64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${this.storeService.getShipNo()}.pdf`;
    link.click();
  }

  handleLabelError(error: any) {
    const errorResponse: ErrorResponse = {
      httpStatus: error.status,
      errorMsg: error.error.errorMsg.map((msg: any) => ({
        errorCode: msg.errorCode,
        field: msg.field,
        idRow: msg.idRow,
        errorMsgLabel: msg.errorMsgLabel,
        errorMsgArgs: msg.errorMsgArgs,
      })),
    };
    if (errorResponse?.errorMsg?.[0]?.errorCode === 'FORBIDDEN') {
      this.captchaDialogService.openCaptchaDialog();
    }
  }

  getPointWorkingHours(): string {
    const dayCodeMap: { [key: number]: string } = {
      0: 'SUNDAY',
      1: 'MONDAY',
      2: 'TUESDAY',
      3: 'WEDNESDAY',
      4: 'THURSDAY',
      5: 'FRIDAY',
      6: 'SATURDAY',
    };
    const today = new Date().getDay();
    const workingHourDto =
      this.storeService.getShippingPointFormData()?.pointDto?.workingHours[
        dayCodeMap[today]
      ];
    if (workingHourDto?.from == undefined || workingHourDto?.to == undefined) {
      return '';
    }
    return (
      'Dzisiejsze godziny otwarcia ' +
      workingHourDto?.from +
      ' - ' +
      workingHourDto?.to
    );
  }

  get mapUrl(): string {
    const pointDto = this.storeService.getShippingPointFormData()?.pointDto;
    return `https://www.google.pl/maps/place/${pointDto?.latitude}+${pointDto?.longitude}`;
  }
}
